/** @format */

import { LuceneExplanation } from '../lucene-explanation.interface';

/**
 * Based on https://github.com/dsg-tech/mtools-article-search/blob/main/src/main/java/com/dsg/mtools/article/search/model/Source.java
 * Unclear what fields are actually optional, these are best guesses based on API responses
 */
export interface Article {
  blurb?: string | null;
  description: string;
  explanation?: LuceneExplanation | null;
  id: string;
  image?: string | null;
  // ISO UTC timestamp (e.g. `2023-08-08T15:13:08.144Z`)
  lastModifiedDate: string;
  score: number;
  tags?: string[] | null;
  title: string;
  url: string;
}
